import { html, ref, repeat } from '@microsoft/fast-element';
import type { LandingPage } from './landing-page';

export const LandingPageTemplate = html<LandingPage>`
    <div class="header-hero-wrapper">
        <div class="header">
            <div class="header-left">
                <div class="logo">CASCADE</div>
            </div>  
            <div class="header-right">
                <div class="main-menu">
                    <zero-button appearance="neutral" class="selected">Welcome</zero-button>
                    <zero-button appearance="neutral">Benefits</zero-button>
                    <zero-button appearance="neutral">Onboarding Process</zero-button>
                    <zero-button appearance="neutral">Important Information</zero-button>
                    <zero-button appearance="neutral">Knowledge Blocks</zero-button>
                </div>
                <zero-button appearance="primary" class="login-button" @click="${x => x.login()}">Login</zero-button>
            </div>
        </div>

        <div class="hero-container">
            <div class="hero-text">
                <div class="hero-title">Change starts here</div>
                <div class="hero-description">With Cascade, it has never been easier to invest and trade in renewable energy</div>
            </div>
            <div ${ref('heroAnimation')} class="hero-animation"></div>
        </div>
    </div>
    <div class="why-cascade-wrapper">
        <div class="why-cascade-container">
            <div class="header">Why Cascade</div>
            <div class="description">Cascade is a revolutionary new platform empowering experienced traders and trading newcomers to invest and trade in renewable energy contracts, all from a powerful and intuitive user interface</div>
            <div class="tiles-wrapper">
                ${repeat(x => x.whyCascadeTiles, html`
                    <div class="tile">
                        <div class="heading">${x => x.heading}</div>
                        <div class="description">${x => x.description}</div>
                    </div>
                `)}
            </div>
        </div>
    </div>
    <div class="footer-wrapper">
        <div class="footer-container">
            <div class="rights">© 2023 Citi Cascade. All rights reserved</div>
            <div class="footer-right">
                <div class="links">
                    ${repeat(x=> x.links, html`
                        <div class="link">${x => x.linkText}</div>
                    `)}
                </div>
            </div>
        </div>
    </div>
`;
